import { IActionCenterSettings } from './action-center-settings';

export interface ISettings extends IActionCenterSettings {
    show: boolean
};
